var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandAll = function SvgExpandAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.373 15.053a.6.6 0 0 1 .848.847l-5.797 5.798a.6.6 0 0 1-.848 0L5.779 15.9a.599.599 0 1 1 .848-.847L12 20.425zM11.67 2.222a.6.6 0 0 1 .754.077l5.797 5.797a.6.6 0 0 1-.848.848L12 3.57 6.627 8.944a.6.6 0 0 1-.848-.848l5.797-5.797z"
  })));
};
export default SvgExpandAll;